import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  HomeIcon,
  DocumentTextIcon,
  ShoppingBagIcon,
  ChartBarIcon,
  Cog6ToothIcon,
  XMarkIcon
} from '@heroicons/react/24/outline';

const menuItems = [
  { text: 'Dashboard', icon: HomeIcon, path: '/dashboard' },
  { text: 'Tenders', icon: DocumentTextIcon, path: '/tenders' },
  { text: 'Products', icon: ShoppingBagIcon, path: '/products' },
  { text: 'Reports', icon: ChartBarIcon, path: '/reports' },
  { text: 'Settings', icon: Cog6ToothIcon, path: '/settings' },
];

const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const navigate = useNavigate();

  return (
    <>
      <aside 
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-white border-r border-gray-200 transform transition-transform duration-200 ease-in-out ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0`}
      >
        {/* Sidebar Header */}
        <div className="h-16 flex items-center justify-between px-4 bg-white border-b border-gray-200">
          <h1 className="text-xl font-semibold text-gray-800">Procureria Admin</h1>
          <button
            onClick={() => setSidebarOpen(false)}
            className="lg:hidden p-2 rounded-md text-gray-500 hover:text-gray-600 hover:bg-gray-100"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto pt-4">
          <div className="px-3">
            {menuItems.map((item) => (
              <a
                key={item.text}
                onClick={() => navigate(item.path)}
                className="flex items-center px-4 py-3 text-gray-600 rounded-lg hover:bg-gray-100 hover:text-gray-900 cursor-pointer transition-colors duration-200 mb-1"
              >
                <item.icon className="w-5 h-5 mr-3" />
                <span className="font-medium">{item.text}</span>
              </a>
            ))}
          </div>
        </nav>

        {/* Sidebar Footer */}
        <div className="border-t border-gray-200 p-4">
          <div className="flex items-center space-x-3">
            <img
              className="h-8 w-8 rounded-full"
              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              alt="User profile"
            />
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-700">John Doe</p>
              <p className="text-xs text-gray-500">Administrator</p>
            </div>
          </div>
        </div>
      </aside>

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 z-40 bg-gray-600 bg-opacity-75 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </>
  );
};

export default Sidebar;